import { Model } from '@vuex-orm/core'

export default class RoomltmsHasOperationmode extends Model{
  static entity = 'roomltmsHasOperationmodes'
  static fields () {
    return {
      roomltms_id: this.attr(null),
      operationmodes_id: this.attr(null),
      default: this.attr(null),
    }
  }
}
  